<a [href]="data.link" class="data.link">
	<button mat-icon-button matTooltip="{{ data.tooltip }}">
		<mat-icon>{{ data.button }}</mat-icon>
	</button>
</a>
